import React, { MouseEventHandler } from "react";
import { PRODUCT_TYPE, IProduct } from "../../../interfaces/products";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { INotification } from "../../../interfaces/notification";
import ProductCard, { ProductCardData } from "../../../components/common/ProductCard";

interface IProps extends RouteComponentProps {
	productType: PRODUCT_TYPE;
	onClick?: () => void;
	product: IProduct;
	onRemoveHandler?: (productId: string) => void;
	notification?: INotification[];
}

const ProductItem: React.FunctionComponent<IProps> = (props) => {
	// Convert IProduct to ProductCardData
	const productData: ProductCardData = {
		id: props.product.id,
		name: props.product.name,
		version: props.product.version,
		image_uri: props.product.image_uri,
		brand: props.product.brand,
		manufacturer: props.product.manufacturer,
		country: props.product.country,
		has_recommendations: props.product.has_recommendations,
		recommendations_count: props.product.recommendations_count
	};


	return (
		<ProductCard
			product={productData}
			productType={props.productType}
			variant="default"
			showActions={true}
			notification={props.notification}
			onShowProductActions={props.onClick}
		/>
	);
};

export default withRouter(ProductItem);
